<!--
  @component BillingScreen — current plan + quota meters + invoices.
  tier:      screen (account-level — `/billing`)
  reads:     useIdentityIO          → user + projects
             useGatesIO             → u2 budget verdict + history
             useLiveTimelineEdge    → gate.* verdict stream
             useIO                  → effecting? → FaceLedgerNotice

  THREE RAILS
  ─────────────────────────────────────────────────────────────────
  1. Current plan   — plan tier + per-month base price + per-project
                      cap. Mocked: real plan tier comes from billing
                      adapter (not yet built).
  2. Usage / quotas — QuotaMeters across compute / bandwidth / storage
                      / rows aggregated across the user's projects.
                      Values are 0 / limit today (no daemon events);
                      the limit numbers come from the plan tier.
  3. Recent budget verdicts — filtered gate.* events from the unified
                      stream. Real u2 budget verdicts get ledgered
                      via GatesIO once the connectors wire in.

  HONEST DEFERRALS
  ─────────────────────────────────────────────────────────────────
  Real invoices / payment method / billing email require a billing
  adapter. This screen is the surface; the data shape it expects
  (plan / quotas / verdicts) is contract-aligned with where the
  adapter will plug in.
-->
<script lang="ts">
  import GatesIO from "../../../global/io/nodes/deployment/GatesIO.svelte";
  import BillingPanel from "./BillingPanel.svelte";
</script>

<!-- GatesIO is the u2 gate tier — surface budget verdicts here.
     It dispatches gated deploys (an op the consumer doesn't itself
     trigger from billing; the screen just reads verdicts + meters). -->
<GatesIO>
  {#snippet children()}
    <BillingPanel />
  {/snippet}
</GatesIO>
